enum PageTypes {
  PRODUCT = 'product',
  CATEGORY = 'category',
  SEARCH_SUGGESTION = 'searchSuggestions',
  LISTING = 'listing',
  LANDING = 'landing',
  HOME = 'home',
  SEARCH_LISTING = 'searchListing',
  FITCODE = 'fitcode',
  OFFER_LISTING = 'offerListing',
  SEARCH_REDIRECTION = 'searchRedirectionPage',
  STORES_N_EVENTS = 'storesNEventsPage',
  ALL_STORES = 'allStoresPage',
  WISHLIST = 'wishlist',
  DYNAMIC_PAGE = 'dynamicPage',
  HLP = 'HybridLP',
  SRC_PAGE = 'srcPage',
  SP_PAGE = 'spPage',
  BESTSELLER_LISTING = 'bestSellerListing',
  SHOPPING_BAG = 'shoppingBag',
}

export default PageTypes;
